export const BID_STATUS = {
  ACCEPTED: 'accepted',
  AWARDED: 'awarded',
  PENDING: 'pending',
  REFUSED: 'refused',
  REMOVED: 'removed',
  TIMED_OUT: 'timed_out',
}
